import { parse, print } from 'graphql';
import { appendDefinitions, getFragmentsUsed, getOperation, setSelectionSet } from "./ast-utils.js";
import { getGraphQLQueryString } from "./graphql-helpers.js";
/**
 * Converts a tool's query ref + selectionSet into a full GraphQL query string.
 * Used by the API for tool execution and by the client for the tool query editor.
 */
export function buildToolQueryString(schemaJson, { queryRef, queryName, selectionSet }) {
    const maxQueryDepth = selectionSet ? 1 : 2;
    const queryString = getGraphQLQueryString(schemaJson, queryRef, { maxQueryDepth, allVars: true });
    if (!selectionSet) {
        return queryString;
    }
    const customSelectionDoc = parse(selectionSet, { noLocation: true });
    const customSelectionSetNode = getOperation(customSelectionDoc)?.selectionSet;
    const baseQueryDoc = parse(queryString, { noLocation: true });
    const queryDoc = appendDefinitions(setSelectionSet(baseQueryDoc, [queryName], customSelectionSetNode, false), getFragmentsUsed(customSelectionDoc));
    return print(queryDoc);
}
